import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=11792330&vue3"
import script from "./popover.vue?vue&type=script&lang=js&vue3"
export * from "./popover.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports